import { render, staticRenderFns } from "./EspacosTable.vue?vue&type=template&id=ac74dcee&scoped=true&"
import script from "./EspacosTable.vue?vue&type=script&lang=js&"
export * from "./EspacosTable.vue?vue&type=script&lang=js&"
import style0 from "./EspacosTable.vue?vue&type=style&index=0&id=ac74dcee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac74dcee",
  null
  
)

export default component.exports